import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewStream = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 18h17v-6H4zM4 5v6h17V5z" />
  </svg>
)
export default SvgViewStream
